import isEqual from 'lodash/isEqual';

import { traverse } from '@atlaskit/adf-utils/traverse/main';
import type { ADFEntity } from '@atlaskit/adf-utils/types';

export const checkIsEqual = (prevADF, nextADF) => {
	const prevHeadings: ADFEntity[] = [];
	const nextHeadings: ADFEntity[] = [];

	// Go through the ADF and push any headings
	// to a new array
	traverse(prevADF || {}, {
		heading: (node) => {
			prevHeadings.push(node);
		},
	});

	traverse(nextADF || {}, {
		heading: (node) => {
			nextHeadings.push(node);
		},
	});

	return isEqual(prevHeadings, nextHeadings);
};
